<template>
  <div class="container">
    <div class="nav">
        <h1>DashBoard</h1>
        <!-- <input type="checkbox" name="" id="theme-toggle" hidden>
        <label for="theme-toggle" class="theme-toggle"></label> -->
        <span class="notif">
            <i class="fa-solid fa-bell"></i>
            <span class="count">{{ proposalsData.length }}</span>
        </span>
    </div>
    <div class="content">


        <!-- Insight -->
        <ul class="insight">
            <li><i class="fa-solid fa-eye"></i>
                <span class="info">
                    <h3>{{ visitorData.length }}</h3>
                    <p>Total Visitors</p>
                </span>
            </li>
            <li><i class="fa-solid fa-bell"></i>
                <span class="info">
                    <h3>{{ reminders.length }}</h3>
                    <p>Total Reminders</p>
                </span>
            </li>
            <li><i class="fa-solid fa-chart-line"></i>
                <span class="info">
                    <h3>{{ proposalsData.length }}</h3>
                    <p>Total Mails</p>
                </span>
            </li>
            <!-- <li><i class="fa-solid fa-chart-line"></i>
                <span class="info">
                    <h3>1,0037</h3>
                    <p>Total Crowd</p>
                </span>
            </li> -->
        </ul>
        <!--x Insight x-->

        <div class="bottom-data">
            <div class="orders">
                <div class="header">
                    <i class="fa-solid fa-envelope" />
                    <h3>({{ proposalsData.length }}) Mails</h3>
                    <i class="fa-solid fa-filter" @click="toggleFilterMenu" ref="filter" />
                    <ul v-show="filterMenu" class="filter-menu">
                        <li @click="filteredProposals">Pending</li>
                        <li @click="filteredProposals">Accepted</li>
                        <li @click="filteredProposals">Declined</li>
                        <li @click="filteredProposals">Clear Filter</li>
                    </ul>
                    <i class="fa-solid fa-search" @click="toggleSearchMenu"/>
                    <div class="search" v-show="searchMenu">
                        <input type="text" placeholder="Search..." v-model="searchQuery" />
                    </div>
                    <!-- <i class="fa-solid fa-arrows-rotate fa-spin" @click="refresh"></i> -->
                </div>

                <div class="table-container" v-if="proposalsLoaded">
                    <table>
                        <thead>
                            <tr>
                                <th>Client Name</th>
                                <th>Mail Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>

                        <tbody v-if="proposalsData.length > 0">
                            <tr v-for="(proposal, index) in filteredData"  :key="index" @click="openModal(proposal.proposalId)">
                                <td>
                                    <p>{{ proposal.clientName }}</p>
                                </td>
                                <td>{{ proposal.submissionDate }}</td>
                                <td><span class="status" :class="{ completed: proposal.status === 'Accepted', pending: proposal.status === 'Pending', declined: proposal.status === 'Declined' }">{{ proposal.status }}</span></td>
                            </tr>
                            <div v-if="filteredData.length === 0 && searchQuery" class="missing">
                                <p>No matching records found.</p>
                            </div>
                        </tbody>

                        <div class="no-data" v-else>
                            <p>There are currently no available proposals 😢</p>
                        </div>
                    </table>

                </div>

                <div class="loader" v-else>
                    <div class="load-content">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                        <p>Fetching Proposals. . .</p>
                    </div>
                </div>
            </div>

            <div class="reminders">
                <div class="header">
                    <i class="fa-solid fa-note" />
                    <h3>({{ reminders.length }}) Reminders</h3>
                    <i class="fa-solid fa-filter" @click="toggleReminderFilter" ref="filter" />
                    <ul v-show="reminderFilter" class="filter-menu">
                        <li @click="filteredReminders">Failed</li>
                        <li @click="filteredReminders">Pending</li>
                        <li @click="filteredReminders">Completed</li>
                        <li @click="filteredReminders">Clear Filter</li>
                    </ul>
                    <i class="fa-solid fa-plus" @click="toggleTodoForm" />

                    <div v-show="showTodoForm" class="todo-form">
                        <input v-model="newReminder" type="text" placeholder="Add a new reminder" />
                        <button @click="createTodo" class="btn cbtn">Create Todo</button>
                    </div>
                </div>



                <div class="table-container" v-if="remindersLoaded">
                    <ul class="task-list" v-if="reminders.length > 0">
                        <li v-for="(reminder, index) in filteredReminderData" :key="index" :class="{ completed: reminder.status === 'Completed', declined: reminder.status === 'Failed', pending: reminder.status === 'Pending' }">
                            <div class="task-title">
                                <i v-show="reminder.status === 'Completed'" class="fa-solid fa-check-circle" />
                                <i v-show="reminder.status === 'Failed'" class="fa-solid fa-circle-xmark"></i>
                                <i v-show="reminder.status === 'Pending'" class="fa-solid fa-circle-minus"></i>
                                <i v-show="reminder.status === 'pending'" class="fa-solid fa-circle-minus"></i>
                                <p>{{ reminder.note }}</p>
                            </div>
                            <div class="icons">
                                <i  v-show="reminder.status === 'Pending'" class="fa-regular fa-square-check" @click="markAsCompleted(index)" />
                                <i  v-show="reminder.status === 'Pending'" class="fa-regular fa-rectangle-xmark" @click="markAsFailed(index)" />
                                <i class="fa-solid fa-trash" @click="deleteReminder(index)"></i>
                            </div>
                        </li>
                    </ul>

                    <div class="no-data" v-else>
                        <p>You haven't created any Reminders!!!</p>
                    </div>
                </div>

                <div class="loader" v-else>
                    <div class="load-content">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                        <p>Fetching Reminders. . .</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="location">
            <div class="location-data">
                <div class="header">
                    <i class="fa-solid fa-receipt" />
                    <h3>Recent Views</h3>
                    <i class="fa-solid fa-filter" />
                    <i class="fa-solid fa-search" />
                </div>
                <div class="table-container" v-if="visitorDataLoaded">
                <!-- <div class="table-container"> -->
                    <table>
                        <thead>
                            <tr>
                                <th>Ip Address</th>
                                <th>Location</th>
                                <th>Date</th>
                                <!-- <th>Date</th> -->
                            </tr>
                        </thead>

                        <tbody v-if="visitorData.length > 0">
                            <tr v-for="(visitor, index) in visitorData" :key="index">
                                <td>
                                    {{ visitor.ip }}
                                </td>
                                <td>{{ visitor.city}}, {{ visitor.country }}</td>
                                <td>{{ visitor.date }}</td>
                            </tr>
                        </tbody>

                        <div class="no-data" v-else>
                            <p>There has been no visitors yet.</p>
                        </div>
                    </table>
                </div>

                <div class="loader" v-else>
                    <div class="load-content">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                        <p>Fetching Data. . .</p>
                    </div>
                </div>
            </div>
        </div>

        <Proposals :isVisible="isModalVisible" :currentProposal="currentProposal" @close="closeModal" />

        
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Proposals from '@/components/Proposals.vue'
import { db, timestamp } from '@/firebase/FirebaseInit'
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import Loading from '@/components/Loading.vue'

export default {
    name: 'Dashboard',
    data() {
        return {
            filterMenu: null,
            reminderFilter: null,
            filteredProposal: null,
            filteredReminder: null,
            searchMenu: null,
            searchQuery: '',
            isModalVisible: false,
            showTodoForm: false,

            loading: true,

            newReminder: '',
            docId: null,
        }
    },
    components: { Proposals, Loading },

    methods: {
        ...mapMutations([ 'PROPOSALS_LOADED', 'SET_CURRENT_PROPOSAL', 'UPDATE_REMINDER_STATUS', 'SET_REMINDERS', 'REMINDERS_LOADED', 'SET_VISITOR_DATA', 'VISITOR_DATA_LOADED' ]),

        ...mapActions([ 'GET_PROPOSALS', 'FETCH_REMINDERS', 'UPDATE_REMINDER_STATUS', 'DELETE_REMINDER', 'STORE_VISITOR_DATA', 'FETCH_VISITOR_DATA', 'START_VISITOR_LISTENER' ]),

        toggleFilterMenu() {
            this.filterMenu = !this.filterMenu;
        },

        toggleReminderFilter() {
            this.reminderFilter = !this.reminderFilter;
        },

        toggleSearchMenu() {
            this.searchMenu = !this.searchMenu;
        },

        toggleTodoForm() {
            this.showTodoForm = !this.showTodoForm;
        },
        
        openModal(proposalId) {
            this.SET_CURRENT_PROPOSAL(proposalId);
            this.isModalVisible = true;
        },

        closeModal() {
            this.isModalVisible = false;
        },

        filteredProposals(e) {
            if (e.target.innerText === 'Clear Filter') {
               this.filteredProposal = null; 
                this.filterMenu = false;
                return;
            }
            
            this.filteredProposal = e.target.innerText;
            this.filterMenu = false;
        },

        filteredReminders(e) {
            if (e.target.innerText === 'Clear Filter') {
                this.filteredReminder = null;
                this.reminderFilter = false;
                return;
            }

            this.filteredReminder = e.target.innerText;
            this.reminderFilter = false;
        },

        async createTodo() {
            if (this.newReminder.trim() !== '') {
                try {
                    const dataBase = await addDoc(collection(db, 'to-do'), {
                        note: this.newReminder,
                        status: 'Pending',
                        timestamp: serverTimestamp(),
                    });

                    this.$toast.open({
                        message: 'To-do successfully created!!!',
                        type: 'success',
                        position: 'bottom-right',
                        duration: 3000,
                    });

                    this.toggleTodoForm();
                    this.newReminder = '';
                    this.FETCH_REMINDERS();

                } catch(error) {
                    console.error('Error creating to-do:', error);
                    this.$toast.open({
                        message: 'Error creating to-do.. Please try again.',
                        type: 'error',
                        position: 'bottom-right',
                        duration: 3000,
                    });
                }
            }
        },

        markAsCompleted(index) {
            try {
                const reminder = this.reminders[index];
                reminder.status = 'Completed';

                // Now, you might want to call an action to update the status in the database
                this.UPDATE_REMINDER_STATUS({ id: reminder.docId, index, status: 'Completed' });

                this.$toast.open({
                    message: 'Successfully Updated.',
                    type: 'success',
                    position: 'bottom-right',
                    duration: 3000,
                });
            } catch (error) {
                console.error('Error Updating reminder:', error);
                this.$toast.open({
                    message: 'Error Updating.. Please try again.',
                    type: 'error',
                    position: 'bottom-right',
                    duration: 3000,
                });
            }
        },

        markAsFailed(index) {
            try {
                const reminder = this.reminders[index];
                reminder.status = 'Failed';

                // Now, you might want to call an action to update the status in the database
                this.UPDATE_REMINDER_STATUS({ id: reminder.docId, index, status: 'Failed' });

                this.$toast.open({
                    message: 'Successfully Updated.',
                    type: 'success',
                    position: 'bottom-right',
                    duration: 3000,
                });
            } catch (error) {
                console.error('Error Updating reminder:', error);
                this.$toast.open({
                    message: 'Error Updating.. Please try again.',
                    type: 'error',
                    position: 'bottom-right',
                    duration: 3000,
                });
            }
        },

        async deleteReminder(index) {
            try {
                const reminder = this.reminders[index];

                this.DELETE_REMINDER({ id: reminder.docId, index });

                this.$toast.open({
                    message: 'Successfully Deleted.',
                    type: 'success',
                    position: 'bottom-right',
                    duration: 3000,
                });
            } catch (error) {
                console.error('Error Updating reminder:', error);
                this.$toast.open({
                    message: 'Error Deleting.. Please try again.',
                    type: 'error',
                    position: 'bottom-right',
                    duration: 3000,
                });
            }

        },

        beforeUnmount() {
            // Call the unsubscribe function to stop listening for updates
            if (this.unsubscribeFromProposals) {
                this.unsubscribeFromProposals();
            }
        },



    },

    created() {
        // this.GET_PROPOSALS();
        this.unsubscribeFromProposals = this.GET_PROPOSALS();
        this.FETCH_REMINDERS();
        // this.FETCH_VISITOR_DATA();
    },

    mounted() {
        this.FETCH_VISITOR_DATA();
        this.unsubscribeVisitorListener = this.START_VISITOR_LISTENER();
    },

    beforeDestroy() {
        if (this.unsubscribeVisitorListener) {
            this.unsubscribeVisitorListener();
        }
    },



    computed: {
        ...mapState(['proposalsLoaded', 'proposalsData', 'currentProposalArray', 'remindersLoaded', 'reminders', 'visitorData', 'visitorDataLoaded']),

        filteredData() {
            return this.proposalsData.filter((proposal) => {
                // console.log('Filtered Proposal:', this.filteredProposal);
                // console.log('Proposal Status:', proposal.status);

                if (this.filteredProposal === 'Accepted' && proposal.status !== 'Accepted') {
                    // console.log('Filtered Out: Accepted');
                    return false;
                }
                if (this.filteredProposal === 'Pending' && proposal.status !== 'Pending') {
                    // console.log('Filtered Out: Pending');
                    return false;
                }
                if (this.filteredProposal === 'Declined' && proposal.status !== 'Declined') {
                    // console.log('Filtered Out: Declined');
                    return false;
                }

                // console.log('Passed Filter');
                // return true;
                const matchesSearchQuery = proposal.clientName.toLowerCase().includes(this.searchQuery.toLowerCase());
                return matchesSearchQuery;
            });
        },

        filteredReminderData () {
            return this.reminders.filter((reminder) => {
                if (this.filteredReminder === 'Failed' && reminder.status !== 'Failed' ) {
                    return false;
                }
                if (this.filteredReminder === 'Pending' && reminder.status !== 'Pending' ) {
                    return false;
                }
                if (this.filteredReminder === 'Completed' && reminder.status !== 'Completed' ) {
                    return false;
                }

                return true;
            })
        },

        currentProposal: state => state.currentProposalArray[0],
    }
}
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
        min-height: 100vh;

        @media(max-width: 750px) {
            // padding: 
        }

        p {
            color: rgb(126, 126, 126);
        }
        .nav {
            height: 10vh;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            align-items: center;
            // border: 1px solid yellow;
            padding: 0 10%;
            background: rgba(255, 255, 255, 0.096);
            backdrop-filter: blur(8px);

            .notif {
                font-size: 20px;
                position: relative;


                .count {
                    position:absolute;
                    top: -6px;
                    right: -6px;
                    width: 20px;
                    height: 20px;
                    background: rgba(255, 0, 0, 0.658);
                    border-radius: 50%;
                    color: white;
                    font-size: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

            }
        }

        .content {
            margin: 0 10%;
            min-height: 100vh;
            padding: 32px 20px;

            @media(max-width: 750px) {
                margin: 32px 5%;
                padding: 32px 10px;
            }

            .insight {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
                grid-gap: 24px;
                margin-top: 4rem;

                li {
                    padding: 24px;
                    border-radius: 20px;
                    background: rgba(255, 255, 255, 0.096);
                    backdrop-filter: blur(8px);
                    display: flex;
                    align-items: center; 
                    grid-gap: 24px;
                    cursor: pointer;
                    z-index: 100;

                    i {
                        width: 80px;
                        height: 80px;
                        border-radius: 10px;
                        font-size:36px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    &:nth-child(1) i {
                        background: rgba(105, 105, 243, 0.808);
                        color: skyblue;
                    }

                    &:nth-child(2) i {
                        background: rgba(247, 105, 54, 0.836);
                        color: rgba(247, 185, 70, 0.76);
                    }

                    &:nth-child(3) i {
                        background: rgba(40, 112, 40, 0.753);
                        color:lightgreen;
                    }

                    &:nth-child(4) i {
                        background: yellowgreen;
                        color: yellow;
                    }

                    .info {
                        h3 {
                            font-size: 23px;
                            color: white;
                        }

                        p {
                            padding-top: .8rem;
                        }
                    }
                }
            }

            .bottom-data {
                display: flex;
                flex-wrap: wrap;
                grid-gap: 24px;
                margin-top: 24px;
                width: 100%;


                .header {
                    display: flex;
                    align-items: center;
                    grid-gap: 1.6rem;
                    margin-bottom: 24px;
                    padding: 0 1rem;
                    position: fixed !important;
                    top: 0;
                    left: 0;
                    width: 100%;
                    padding: 1rem .5rem;
                    background: black;
                    z-index: 20;

                    h3 {
                        margin-right: auto;
                        font-size: 24px;
                        font-weight: 600;
                    }

                    i {
                        cursor: pointer;
                    }

                    .filter-menu {
                        width: 100%;
                        position: absolute;
                        top: 100%;
                        left: 0;
                        list-style: none;
                        background: black;

                        li {
                            cursor: pointer;
                            font-size: 12px;
                            padding: 10px 20px;
                            list-style: none;
                            color: white;

                            &:hover {
                                color: white;
                                background: rgba(128, 128, 128, 0.527);
                            }
                        }
                    }

                    .search {
                        width: 100%;
                        position: absolute;
                        top: 100%;
                        left: 0;
                        background: black;
                        display: flex;
                        justify-content: center;

                        input {
                            outline: none;
                            margin: 1.4rem;
                            width: 90%;
                            padding: .7rem 1.4rem;
                            color: black;
                        }
                    }

                    .todo-form {
                            width: 100%;
                            position: absolute;
                            top: 100%;
                            left: 0;
                            background: black;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            flex-direction: column;

                            input {
                                outline: none;
                                margin: 1.4rem;
                                width: 90%;
                                padding: .7rem 1.4rem;
                                color: black;
                            }

                            .btn {
                                display: flex;
                                justify-content: center;
                                width: fit-content;
                                align-items: center;
                                padding: .6rem .9rem;
                                border-radius: 20px;
                                border: none;
                                margin-bottom: 1.5rem;
                                cursor: pointer;
                            }
                        }
                }

                .orders {
                    flex-grow: 1;
                    flex-basis: 500px;

                    .table-container {
                        height: 50vh;
                        overflow: auto;
                    }


                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 7vh;

                        th {
                            padding-bottom: 1.5rem;
                            font-size: 13px;
                            text-align: left;
                            border-bottom: 1px solid gray;
                        }

                        td {
                            padding: 16px 0;
                        }
                        
                        tr {
                            
                            td:first-child {
                                display: flex;
                                align-items: center;
                                grid-gap: 12px;
                                padding-left: 6px;
                            }
                        }

                        tbody {
                            tr {
                                cursor: pointer;
                                transition: all .3s ease;

                                &:hover {
                                    background: rgba(255, 255, 255, 0.247);
                                }
                            }
                        }


                    }


                }

                .reminders {
                    flex-grow: 1;
                    flex-basis: 300px;

                    .table-container {
                        height: 50vh;
                        overflow: auto;
                    }

                    .task-list {
                        width: 100%;
                        margin-top: 7vh;

                        li {
                            width: 100%;
                            margin-bottom: 16px;
                            padding:14px 10px;
                            background:rgba(128, 128, 128, 0.507);
                            border-radius: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .task-title {
                                display: flex;
                                align-items: center;

                                p {
                                    margin-left: 6px;
                                    color: white;
                                }
                            }

                            .icons {
                                display: none;
                                // font-size: 13px;
                                // align-items: center;
                                text-align: center;

                                i {
                                    cursor: pointer;
                                    margin: 0 .3rem;
                                    font-size: 1rem;

                                    &:first-child:hover {
                                        color: rgb(94, 238, 94);
                                    }

                                    &:nth-child(2):hover {
                                        color: rgb(231, 81, 81);
                                    }
                                }
                            }

                            &:hover {
                                .icons {
                                    display: initial;
                                }
                            }


                        }
                        .completed {
                            border-left: 8px solid rgb(86, 228, 86);
                        }
                        
                        .declined {
                            border-left: 8px solid rgb(224, 62, 62);
                        }
                        
                        .pending {
                            border-left: 8px solid #e2764b;
                        }

                    }

                    
                    .no-data {
                        // width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                        margin-top: 13vh;
                        padding: 1.5rem 2rem;

                        p {
                            text-align: center;
                        }
                    }
                }
            }

            .bottom-data>div {
                border-radius: 20px;
                background: rgba(255, 255, 255, 0.096);
                backdrop-filter: blur(8px);
                overflow-x: auto;
                padding: 25px;
            }

            .location {
                display: flex;
                flex-wrap: wrap;
                grid-gap: 24px;
                margin-top: 24px;
                width: 100%;

                .header {
                    display: flex;
                    align-items: center;
                    grid-gap: 1.6rem;
                    margin-bottom: 24px;
                    padding: 0 1rem;
                    position: fixed !important;
                    top: 0;
                    left: 0;
                    width: 100%;
                    padding: 1rem .5rem;
                    background: black;
                    z-index: 20;

                    h3 {
                        margin-right: auto;
                        font-size: 24px;
                        font-weight: 600;
                    }

                    i {
                        cursor: pointer;
                    }

                }

                .location-data {
                    flex-grow: 1;
                    flex-basis: 100%;
                    width: 100%;

                        
                    .table-container {
                        height: 40vh;
                        overflow: auto;
                    }

                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 7vh;

                        th {
                            padding-bottom: 1.5rem;
                            font-size: 13px;
                            text-align: center;

                        }

                        td {
                            padding: 16px 0;
                        }
                        
                        tr {
                            // text-align:center;

                            td:first-child {
                                display: flex;
                                align-items: center;
                                grid-gap: 12px;
                                padding-left: 6px;
                            }
                        }



                        tbody {
                            tr {
                                cursor: pointer;
                                transition: all .3s ease;
                                text-align: center;

                                td:first-child {
                                    align-items: center;
                                }

                                &:hover {
                                    background: rgba(255, 255, 255, 0.247);
                                }

                            }

                            i {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                background: rgba(145, 143, 143, 0.733);
                                color: white;
                                text-align: center;
                                font-size: .7rem;
                                align-items: center;
                                display: flex;
                                justify-content: center;
                            }
                        }
                    }
                }
            }

            .location>div {
                border-radius: 20px;
                background: rgba(255, 255, 255, 0.096);
                backdrop-filter: blur(8px);
                overflow-x: auto;
                padding: 25px;
            }
            .loader {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;

                .load-content {
                    text-align: center;

                    i {
                        font-size: 1.5rem;
                        padding: 1rem;
                    }

                    p {
                        font-size: 1.5rem;
                        margin: 1rem;
                    }
                }
            }

            .missing {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: auto;
                height: 100%;
            }
            
            .no-data {

                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                padding: 1.5rem 2rem;
                // height: 100%;

                p {
                    text-align: center;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>